import * as Types from '../../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RecordSurveySubmittedMutationVariables = Types.Exact<{
  input: Types.RecordSurveySubmittedInput;
}>;


export type RecordSurveySubmittedMutation = { __typename?: 'Mutation', recordSurveySubmitted?: { __typename?: 'RecordSurveySubmittedPayload', surveyId: string } | null };


export const RecordSurveySubmittedDocument = gql`
    mutation RecordSurveySubmitted($input: RecordSurveySubmittedInput!) {
  recordSurveySubmitted(input: $input) {
    surveyId
  }
}
    `;
export type RecordSurveySubmittedMutationFn = Apollo.MutationFunction<RecordSurveySubmittedMutation, RecordSurveySubmittedMutationVariables>;

/**
 * __useRecordSurveySubmittedMutation__
 *
 * To run a mutation, you first call `useRecordSurveySubmittedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordSurveySubmittedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordSurveySubmittedMutation, { data, loading, error }] = useRecordSurveySubmittedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecordSurveySubmittedMutation(baseOptions?: Apollo.MutationHookOptions<RecordSurveySubmittedMutation, RecordSurveySubmittedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordSurveySubmittedMutation, RecordSurveySubmittedMutationVariables>(RecordSurveySubmittedDocument, options);
      }
export type RecordSurveySubmittedMutationHookResult = ReturnType<typeof useRecordSurveySubmittedMutation>;
export type RecordSurveySubmittedMutationResult = Apollo.MutationResult<RecordSurveySubmittedMutation>;
export type RecordSurveySubmittedMutationOptions = Apollo.BaseMutationOptions<RecordSurveySubmittedMutation, RecordSurveySubmittedMutationVariables>;